import React from 'react'
import { observer } from 'mobx-react-lite'
import { getContentfulImageURL } from '../../../../lib/helpers'

import css from 'styled-jsx/css'

function getStyles(category) {
	return css.resolve`
		div {
			background-repeat: no-repeat;
			background-position: center center;
			background-color: #ccc;

			width: 100%;
			height: 20em;
			background-size: cover;

			-moz-transform: translatez(0);
			-ms-transform: translatez(0);
			-o-transform: translatez(0);
			-webkit-transform: translateZ(0);
			-webkit-font-smoothing: antialiased;
		}
		@media only screen and (max-width: 768px), (pointer: coarse) {
			div {
				display: none;
			}
		}
	`
}

// squiggly box
const ClipShapeOne = ({ id }) => {
	return (
		<svg viewBox="0 0 83.29 79.9">
			<defs>
				<clipPath
					id={`clip-path-${id}`}
					transform={`scale(${0.4915 / 4} ${0.561 / 4})`}
				>
					<path
						class="cls-1"
						d="M81.42,56.18C81,67,71.27,78.05,55.5,78.05H3.42A3.43,3.43,0,0,1,0,74.61H0V3.44A3.43,3.43,0,0,1,3.42,0H52.65c5.87,0,11.93,1.28,16.73,4.86s7.48,9.05,8.51,14.46a22.24,22.24,0,0,1-4.14,17.6c-.58.79.92,1.79,1.38,2.25a20.44,20.44,0,0,1,4.61,6.59,24.56,24.56,0,0,1,1.71,9.67c0,.25,0,.5,0,.75"
					/>
				</clipPath>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_1-2" data-name="Layer 1">
					<g id="Layer_2-2" data-name="Layer 2">
						<g id="Layer_1-2-2" data-name="Layer 1-2">
							<g class="cls-2">
								<rect width="83.29" height="79.9" />
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

// b shape
const ClipShapeTwo = ({ id }) => {
	return (
		<svg viewBox="0 0 100 100">
			<defs>
				<clipPath id={`clip-path-${id}`} transform="scale(.59 .578)">
					<path
						class="cls-1"
						d="M441.27,304.48C439.06,363.1,386.22,423,300.79,423H18.56A18.6,18.6,0,0,1,0,404.36V18.64A18.6,18.6,0,0,1,18.56,0H285.33C317.13,0,350,6.94,376,26.32c25.28,18.9,40.53,49.07,46.15,78.36,7.1,37-3.9,70-22.47,95.43-3.11,4.26,5,9.66,7.51,12.17,10.48,10.64,19.23,21.85,24.95,35.7,6.84,16.55,9.52,34.59,9.29,52.43,0,1.36-.06,2.72-.11,4.07"
					/>
				</clipPath>
			</defs>
		</svg>
	)
}

// vase shape
const ClipShapeThree = ({ id }) => {
	return (
		<>
			<svg viewBox="0 0 100 100">
				<defs>
					<clipPath id={`clip-path-${id}`} transform="scale(.5525 .612)">
						<path
							class="cls-1"
							d="M49,0H413.74A49,49,0,0,1,459,67.87L420,161.13a49,49,0,0,0,0,37.74L459,292.13A49,49,0,0,1,413.74,360H49A49,49,0,0,1,4,291.74l39.53-92.48a49,49,0,0,0,0-38.52L4,68.26A49,49,0,0,1,49,0Z"
						/>
					</clipPath>
				</defs>
			</svg>
			<style jsx>{`
				svg {
					transform: translateY(-25px);
				}
			`}</style>
		</>
	)
}

// rounded rect shape
const ClipShapeFour = ({ id }) => {
	return (
		<svg viewBox="0 0 100 100">
			<defs>
				<clipPath id={`clip-path-${id}`} transform="scale(.5525 .5525)">
					<rect class="cls-1" width="441" height="441" rx="97" />
				</clipPath>
			</defs>
		</svg>
	)
}

// s svg shape
const ClipShapeFive = ({ id }) => {
	return (
		<svg viewBox="0 0 100 100">
			<defs>
				<clipPath id={`clip-path-${id}`} transform="scale(.544 .51)">
					<path
						class="cls-1"
						d="M100,0H481a32,32,0,0,1,32,32V308A100,100,0,0,1,413,408H32A32,32,0,0,1,0,376V100A100,100,0,0,1,100,0Z"
					/>
				</clipPath>
			</defs>
		</svg>
	)
}

// dots shape needs most revision most likely
const ClipShapeSeven = ({ id }) => {
	return (
		<svg viewBox="0 0 100 100">
			<defs>
				<clipPath
					id={`clip-path-${id}`}
					transform={`scale(${(4 * 0.5525) / 5}, ${(4 * 0.5525) / 5})`}
				>
					<path
						class="cls-1"
						d="M477.28,0a159.25,159.25,0,1,1-78.7,297.75,159.58,159.58,0,0,1-159.25-1.07A158.95,158.95,0,0,1,0,162C-1.5,73,70.08,0,158.78,0a158.51,158.51,0,0,1,80.71,21.91,159,159,0,0,1,159.25-1.07A157.49,157.49,0,0,1,477.28,0Z"
					/>
				</clipPath>
			</defs>
		</svg>
	)
}

const Image = observer(({ src, active, index, category }) => {
	const { className, styles } = getStyles(category)

	const image = src?.profilePicture?.file
		? getContentfulImageURL(src.profilePicture.file, 800, 90)
		: false

	return (
		<>
			<div>
				<img src={image} />
			</div>

			{styles}
			<style jsx>{`
				div {
					padding: 0 1.25rem;
				}

				img {
					max-width: ${category === 'Collaborator' 
						? '50%'
						: '80%'};
				}
				@media only screen and (max-width: 768px), (pointer: coarse) {
					div {
						display: none;
					}
				}
			`}</style>
		</>
	)
})

export default Image
